// 骨架屏:羊皮纸微光占位,取代各处敷衍的「…」。尺寸尽量贴近真实内容以减少 CLS。

function Sk({ w, h, r, className, style }: { w?: number | string; h?: number | string; r?: number; className?: string; style?: React.CSSProperties }) {
  return (
    <span
      className={`sk${className ? ' ' + className : ''}`}
      style={{ width: w, height: h, borderRadius: r, ...style }}
    />
  );
}

/** 排行榜列表行骨架(rank·头像·名字·数值)。用于内嵌/独立榜加载态。 */
export function LbRowsSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <ul className="lb-list sk-list" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <li key={i} className="lb-row sk-row">
          <Sk w={22} h={22} r={11} />
          <Sk w={26} h={26} r={13} />
          <Sk w={`${45 + ((i * 13) % 40)}%`} h={13} r={4} className="sk-grow" />
          <Sk w={54} h={12} r={4} />
        </li>
      ))}
    </ul>
  );
}

/** 完整排行榜骨架(标题+个人卡+Tab+列表),用于懒加载整块榜时。 */
export function LeaderboardSkeleton() {
  return (
    <div className="lb lb-embedded" aria-busy="true">
      <Sk w={190} h={26} r={5} style={{ margin: '0 auto 18px' }} />
      <div className="lb-mystats sk-mystats">
        <Sk w={70} h={9} r={3} />
        <div className="lb-ms-body">
          <div className="lb-ms-head">
            <Sk w={40} h={40} r={20} />
            <div className="lb-ms-id" style={{ gap: 6 }}>
              <Sk w={120} h={15} r={4} />
              <Sk w={90} h={11} r={4} />
            </div>
          </div>
          <div className="sk-statgrid">
            {Array.from({ length: 4 }).map((_, i) => (
              <Sk key={i} w={44} h={26} r={5} />
            ))}
          </div>
        </div>
      </div>
      <Sk w={320} h={38} r={999} style={{ margin: '0 auto 16px', maxWidth: '90%' }} />
      <LbRowsSkeleton rows={6} />
    </div>
  );
}

/** Connections 棋盘骨架:16 格 + 操作条,贴合预留高度。 */
export function ConnectionsSkeleton() {
  return (
    <div className="conn" aria-busy="true">
      <Sk w={170} h={16} r={4} style={{ margin: '0 auto 18px', display: 'block' }} />
      <div className="conn-grid">
        {Array.from({ length: 16 }).map((_, i) => (
          <Sk key={i} h={84} r={9} />
        ))}
      </div>
      <div className="sk-conn-bar">
        <Sk w={90} h={16} r={4} />
        <div style={{ display: 'flex', gap: 8 }}>
          <Sk w={92} h={34} r={999} />
          <Sk w={92} h={34} r={999} />
          <Sk w={92} h={34} r={999} />
        </div>
      </div>
    </div>
  );
}

/** Classic/Flag/Outline 猜词区骨架:输入条 + 提示行。 */
export function GuessSkeleton() {
  return (
    <div className="sk-guess" aria-busy="true">
      <Sk h={58} r={12} className="sk-input" />
      <Sk w={260} h={14} r={4} style={{ margin: '26px auto 0', display: 'block', maxWidth: '80%' }} />
    </div>
  );
}

/** 公开资料页骨架:头像 + 名字 + 段位 + 统计网格。 */
export function ProfileSkeleton() {
  return (
    <div className="profile" aria-busy="true">
      <div className="profile-card">
        <Sk w={84} h={84} r={42} style={{ margin: '0 auto' }} />
        <Sk w={160} h={22} r={5} style={{ margin: '14px auto 8px' }} />
        <Sk w={200} h={14} r={4} style={{ margin: '0 auto 6px' }} />
        <div className="profile-grid" style={{ marginTop: 18 }}>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
              <Sk w={40} h={22} r={5} />
              <Sk w={54} h={10} r={3} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
